// extracted by extract-css-chunks-webpack-plugin
module.exports = {"swiperBanner":"swiperBanner_ZEUWU","ui_mask":"ui_mask_CrBRm"};